import { Box, Button, Typography } from "@mui/material"
import { exportTanClientForm, getClientForm, getIncomeTaxProfile, getTanClientsCredentials } from "api/services/automation/income-tax-tan";
import Table from "components/Table";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { StyledSpan } from "../../styles";
import { useState } from "react";
import AccessDenied from "../../Access/accessDenide";
import Loader from "components/Loader";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { getCurrentFormattedDateTime } from "utils";
import { getClient } from "api/services/clients/clients";
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";


const TanClientForm = (state) => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate()
    const [page, setPage] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [checkAccess, setCheckAccess] = useState(true)
    let defaultColumns = [
        {
            key: "id",
            title: "Financial Year",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
            render: (row: any) => {
                return (
                    <Box color="#ffffff">
                        <StyledSpan bgColor={row?.refYearType === "FY" ? "#005580" : "#7e8bca"} >{row?.refYear ? `${row?.refYearType} ${calculateAssessmentYear(row?.refYear)}` : ""}</StyledSpan>

                    </Box>
                )
            },
        },
        {
            key: "filingTypeCd",
            title: "Filing Type",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "financialQuarter",
            title: "Quarter",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "formDesc",
            title: "Form Name",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "tempAckNo",
            title: "RRR#",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "ackDt",
            title: "Date of Filing",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "status",
            title: "Proceesing Status",
            render: (row: any) => {
                return (
                    <Typography>{row?.status ? row?.status : '-'}</Typography>
                )
            }
        },
        {
            key: "dtOfPrcng",
            title: "Date of Processing",
             render: (row: any) => {
                return (
                    <Typography>{row?.dtOfPrcng ? row?.dtOfPrcng : '-'}</Typography>
                )
            }
        },
        {
            key: "udinNum",
            title: "UDIN",
            render: (row: any) => {
                return (
                    <Typography>{row?.udinNum ? row?.udinNum : '-'}</Typography>
                )
            }
        },
    ];

  const [sort, setSort] = useState<any>({});
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
    const { data, isLoading }: ResType = useQuery(
        ["get-form-data-tan", params.incometaxid, { limit: pageCount, offset: page * pageCount,sort }],
        getClientForm,
        {
            onSuccess: (res) => {
                console.log(res)
                setCheckAccess(res?.data?.accessDenied)
                setTotalCount(res?.data?.count);
            },
        }
    );


    const { data: clientData, isLoading: isLoading1 }: ResType = useQuery(
        ["get-income-tax-tan-profile", params.incometaxid],
        getIncomeTaxProfile,
    );
    const clientName = clientData?.data?.profileDetails?.name;

    const { mutate: mutate1 } = useMutation(exportTanClientForm, {
        onSuccess: (res: any) => {
            const arr = new Uint8Array(res.data?.data);
            const blob = new Blob([arr], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const file = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            const formattedDateTime = getCurrentFormattedDateTime();
            link.href = file;
            link.download = `ATOM Pro - ${clientName} Income Tax Forms ${formattedDateTime}.xlsx`;
            link.click();
            snack.success("Income Tax Forms exported successfully");
        },
        onError: (err: any) => {
            snack.error(err);
            snack.error(handleError(err));
        },
    });
    const handleExport = () => {
        mutate1({
            ...state,
            incometaxid: params.incometaxid
        });
    };
    function calculateAssessmentYear(startYear) {
        const endYear = parseInt(startYear) + 1;
        return startYear + "-" + endYear.toString().slice(2);
    }

    const handleSort = (v: any) => {
        sortHandler({
          key: v.key,
          columns,
          sortState: sort,
          setSortState: setSort,
          setColumns: setColumns,
        });
      };
    const handleRowClick = (v: any) => {
        navigate(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/form/${v?.id}`)
    }

    if (isLoading) return <Loader />
    return (
        <>
            <Box display="flex" justifyContent="flex-end" m={2}>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleExport}
                    startIcon={<FileDownloadOutlinedIcon />}
                >
                    Export
                </Button>
            </Box>
            <Box pl={1} pr={1}>
                {!checkAccess && (
                    <AccessDenied />
                )}

                {checkAccess && (
                    <Box>
                        {data && data?.data.count > 0 ?
                            <>
                                <Table
                                    sx={{ height: '460px' }}
                                    // selection={{ selected, setSelected }}
                                    pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
                                    data={data?.data?.result || []}
                                    columns={columns}
                                    sortHandler={handleSort}
                                    loading={isLoading}
                                    onRowClick={handleRowClick}
                                />
                            </> : <>
                                <Box textAlign="center" mt={20}>
                                    <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">
                                        No Data present
                                    </Typography>
                                </Box>
                            </>}
                    </Box>
                )}
            </Box>
        </>
    )
}

export default TanClientForm